import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import { MktButton, PasswordInput, VerifyCodeInput, UseHeader, UserNameInput, MergeModal, TipModal } from '@cps'
import { toast, modalLayer } from '@utils'
import { memberMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import './index.scss'

// interface
interface IProps {
  reject?: () => void;
  resolve?: () => void;
}

const Forget: FC<IProps> = (props: IProps) => {
  const { resolve, reject } = props
  const { binding: verifyCodeBind, merge: verifyCodeMerge, register: verifyCodeRegister } = memberMobx.verifyCodeTypes
  const [mobileInfo, setMmobileInfo] = useState<any>({})
  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  const [passwordInfo, setPasswordInfo] = useState<any>({})
  const [codeType, setCodeType] = useState<string>(verifyCodeBind)
  let posting = false
  const handleSave = () => {
    if (!mobileInfo.valid) {
      toast({ message: i18n.t('common.numberTips') })
      return
    }
    if (!verifyCodeInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    if (!passwordInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    } else if (!passwordInfo.valid) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    }
    const params: any = {
      mobile: mobileInfo.inputValue,
      countryCode: mobileInfo.countryCode,
      captcha: verifyCodeInfo.inputValue,
      loginPwd: passwordInfo.inputValue
    }
    if (posting) return
    posting = true
    if (codeType === verifyCodeBind || codeType === verifyCodeRegister) {
      memberMobx.bindingAccount(params).then((success: any) => {
        if (success) {
          toast({ message: i18n.t('mkt.giftCard.bindSuccess') })
          resolve()
        }
        posting = false
      }).catch(() => {
        posting = false
      })
    } else if (codeType === verifyCodeMerge) {
      memberMobx.merge(params).then((success: any) => {
        if (success) {
          modalLayer(TipModal, {
            content: i18n.t('mkt.member.mergeSuccess1', { countryCode: mobileInfo.countryCode, mobile: mobileInfo.inputValue }),
            okText: i18n.t('cart.ikonw'),
          }).then(() => {
            resolve()
          })
        }
        posting = false
      }).catch(() => {
        posting = false
      })
    }
  }
  // Component Event
  const checkIsRegister = (value: any) => {
    setMmobileInfo(value)
    if (value.valid) {
      const params: any = {
        mobile: value.inputValue,
        countryCode: Number(value.countryCode)
      }
      memberMobx.checkAccount(params).then((res: any) => {
        if (res && res.isRegister) {
          setCodeType(verifyCodeMerge)
          modalLayer(MergeModal, {
            info: {
              type: 'mobile',
              account: value.inputValue,
              countryCode: value.countryCode
            }
          }).then(() => {}).catch(() => {
            reject()
          })
        } else {
          setCodeType(memberMobx?.memberInfo?.memberId ? verifyCodeBind : verifyCodeRegister)
        }
      })
    }
  }
  useEffect(() => {
    setMmobileInfo({})
    setVerifyCodeInfo({})
    setPasswordInfo({})
  }, [])
  return (
    <IonModal
      cssClass='bind-mobile-modal'
      isOpen
    >
      <UseHeader onBack={reject}></UseHeader>
      <IonContent className='page-content'>
        <div className='panel'>
          <div className='body'>
            <div className='input-item'>
              <UserNameInput type='mobile' onChange={(val: any) => { checkIsRegister(val) }}></UserNameInput>
            </div>
            <div className='input-item'>
              <VerifyCodeInput codeType={codeType} account={mobileInfo.valid ? mobileInfo.inputValue : ''} accountType='mobile' countryCode={mobileInfo.countryCode} onChange={(val: any) => setVerifyCodeInfo(val)} />
            </div>
            <div className='input-item'>
              <PasswordInput onChange={(val: any) => setPasswordInfo(val)} />
            </div>
          </div>
          <div className='footer'>
            <MktButton text={i18n.t('mkt.common.finish')} onClick={handleSave} />
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(Forget)
